import { Boolean, Literal, Partial, Record, Static, Union } from "runtypes";

import { getNormalEnum } from "./runtypeEnums.js";

const UserInteractionLiteral = Union(
  Literal("PROJECT_ONBOARDING_DISMISSED"), // deprecated, no longer used
  Literal("PROJECT_ONBOARDING_COLLAPSED"), // deprecated, no longer used
  Literal("EXPLORE_FROM_HERE_CALLOUT_DISMISSED"),
  Literal("NEW_PROJECT_TOUR_STARTED"),
  Literal("APP_VIEW_TOUR_STARTED"),
  Literal("TEMPLATE_SIDEBAR_TOOLTIP_SHOWN"),
  Literal("TEMPLATE_DATA_SOURCES_TOOLTIP_SHOWN"),
  Literal("DEBUG_MODE_CALLOUT_DISMISSED"),
  Literal("PRESENTATION_MODE_CALLOUT_DISMISSED"),
  Literal("NOTIFICATION_INBOX_OPENED"),
  Literal("DATA_MANAGER_DIALOG_DISMISSED"),
  Literal("HOME_PAGE_ONBOARDING_DISMISSED"),
  Literal("LEARN_SIDEBAR_DEFAULT_OPEN"), // deprecated, no longer used
  Literal("CALCS_AWARENESS_INDICATOR_DISMISSED"), // deprecated, no longer used
  Literal("ENDORSED_DATA_MAGIC_AWARENESS_INDICATOR_DISMISSED"), // deprecated
  Literal("CONDITIONAL_NOTIFICATION_ICON_CLICKED"), // deprecated
  Literal("ASK_MAGIC_INDICATOR_DISMISSED"),
  Literal("SAVED_VIEW_CTA_CLICKED"), // deprecated
  Literal("SEMANTIC_MODEL_AWARENESS_INDICATOR_DISMISSED"), // deprecated, no longer used
  Literal("MAGIC_2025_TOS_DIALOG_DISMISSED"),
  Literal("EXPLORE_ENDORSED_DATA_INFO_DISMISSED"),
  Literal("THREADS_TALK_TO_DATA_INFO_DISMISSED"),
  Literal("THREADS_INTRO_DIALOG_DISMISSED"),
  Literal("THREADS_SLACK_POPOVER_DISMISSED"),
  Literal("THREADS_SLACK_ADMIN_POPOVER_DISMISSED"),
  Literal("TRIAL_ENDING_DIALOG_DISMISSED"),
  Literal("CREATOR_ONBOARDING_COMPLETED"),
  Literal("CHAT_WITH_APP_AWARENESS_INDICATOR_DISMISSED"),
  Literal("CHAT_WITH_APP_DISCOVERY_CARD_DISMISSED"),
  Literal("SQL_CELL_OUTPUT_AWARENESS_INDICATOR_DISMISSED"),
  Literal("CONTEXT_STUDIO_SETUP_DISMISSED"),
  Literal("AGENT_DESKTOP_NOTIFICATION_CTA_DISMISSED"),
  Literal("ASK_FROM_APP_AGENT_FAB_MOVED_DISMISSED"),
);

export const UserInteraction = getNormalEnum(UserInteractionLiteral);
export type UserInteraction = Static<typeof UserInteractionLiteral>;

// Using a Record instead of a Dictionary since we want to support other types of values.
export const UserInteractions = Record({
  [UserInteraction.PROJECT_ONBOARDING_DISMISSED]: Boolean,
  [UserInteraction.PROJECT_ONBOARDING_COLLAPSED]: Boolean,
  [UserInteraction.EXPLORE_FROM_HERE_CALLOUT_DISMISSED]: Boolean,
  [UserInteraction.NEW_PROJECT_TOUR_STARTED]: Boolean,
  [UserInteraction.APP_VIEW_TOUR_STARTED]: Boolean,
  [UserInteraction.TEMPLATE_SIDEBAR_TOOLTIP_SHOWN]: Boolean,
  [UserInteraction.TEMPLATE_DATA_SOURCES_TOOLTIP_SHOWN]: Boolean,
  [UserInteraction.DEBUG_MODE_CALLOUT_DISMISSED]: Boolean,
  [UserInteraction.PRESENTATION_MODE_CALLOUT_DISMISSED]: Boolean,
  [UserInteraction.NOTIFICATION_INBOX_OPENED]: Boolean,
  [UserInteraction.HOME_PAGE_ONBOARDING_DISMISSED]: Boolean,
  [UserInteraction.LEARN_SIDEBAR_DEFAULT_OPEN]: Boolean,
  [UserInteraction.CALCS_AWARENESS_INDICATOR_DISMISSED]: Boolean,
  [UserInteraction.ENDORSED_DATA_MAGIC_AWARENESS_INDICATOR_DISMISSED]: Boolean,
  [UserInteraction.CONDITIONAL_NOTIFICATION_ICON_CLICKED]: Boolean,
  [UserInteraction.ASK_MAGIC_INDICATOR_DISMISSED]: Boolean,
  [UserInteraction.SAVED_VIEW_CTA_CLICKED]: Boolean,
  [UserInteraction.SEMANTIC_MODEL_AWARENESS_INDICATOR_DISMISSED]: Boolean,
  [UserInteraction.MAGIC_2025_TOS_DIALOG_DISMISSED]: Boolean,
  [UserInteraction.EXPLORE_ENDORSED_DATA_INFO_DISMISSED]: Boolean,
  [UserInteraction.THREADS_TALK_TO_DATA_INFO_DISMISSED]: Boolean,
  [UserInteraction.THREADS_INTRO_DIALOG_DISMISSED]: Boolean,
  [UserInteraction.TRIAL_ENDING_DIALOG_DISMISSED]: Boolean,
  [UserInteraction.CREATOR_ONBOARDING_COMPLETED]: Boolean,
  [UserInteraction.THREADS_SLACK_POPOVER_DISMISSED]: Boolean,
  [UserInteraction.THREADS_SLACK_ADMIN_POPOVER_DISMISSED]: Boolean,
  [UserInteraction.CHAT_WITH_APP_AWARENESS_INDICATOR_DISMISSED]: Boolean,
  [UserInteraction.CHAT_WITH_APP_DISCOVERY_CARD_DISMISSED]: Boolean,
  [UserInteraction.SQL_CELL_OUTPUT_AWARENESS_INDICATOR_DISMISSED]: Boolean,
  [UserInteraction.CONTEXT_STUDIO_SETUP_DISMISSED]: Boolean,
  [UserInteraction.AGENT_DESKTOP_NOTIFICATION_CTA_DISMISSED]: Boolean,
  [UserInteraction.ASK_FROM_APP_AGENT_FAB_MOVED_DISMISSED]: Boolean,
});
export type UserInteractions = Static<typeof UserInteractions>;
export const PartialUserInteractions = Partial(UserInteractions.fields);
export type PartialUserInteractions = Static<typeof PartialUserInteractions>;
